import { useParams } from "react-router-dom";
import { useStateMachine } from "little-state-machine";

import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import usePermissions from "hooks/usePermissions";
import { ShipmentTypes } from "constants/index";
import testIds from "constants/testIds";
import ShipperActionButtons from "./ShipperActionButtons";
import ProviderQuotationActionButtons from "./ProviderActionButtons/ProviderQuotationActionButtons";
import ProviderTrackingActionButtons from "./ProviderActionButtons/ProviderTrackingActionButtons";
import CommonActionButtons from "./CommonActionButtons";

interface ActionButtonsProps {
  isQuickRequest: boolean;
  tabTitle: string;
  isLoading: boolean;

  isProviderQuotationPage: boolean;
  isProviderTrackingPage: boolean;
  hasParentShipment: boolean;
  isGuest?: boolean;
}

export default function ActionButtons({
  isQuickRequest,
  tabTitle,
  isLoading,
  hasParentShipment,
  isProviderQuotationPage,
  isProviderTrackingPage,
  isGuest = false,
}: ActionButtonsProps) {
  const { permissions } = usePermissions();
  const user_type = permissions ? JSON.parse(permissions).user_type : null;
  const isShipper = user_type === "shipper";

  const { state } = useStateMachine() as any;
  const { id } = useParams();
  const shipmentId = (id || state.shipmentId) as string;

  const { data: shipmentBasicData }: any = useGetShipmentBasic(shipmentId, {
    enabled: !isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });
  const isMultiStop = shipmentBasicData?.shipment?.shipment_type === ShipmentTypes.MULTISTOP;
  const showIntermediateInMultistopComposer = isMultiStop && isProviderTrackingPage && !isShipper;

  if (isLoading || isGuest) return null;

  return (
    <div className="d-flex flex-wrap gap-sm" data-testid={testIds.TOPNAV_V2_SHIPPER_PROVIDER_ACTIONS_CONTAINER}>
      <CommonActionButtons
        isQuickRequest={isQuickRequest}
        tabTitle={tabTitle}
        intermediateInvoice={showIntermediateInMultistopComposer ? <ProviderTrackingActionButtons /> : undefined}
      />
      {isShipper ? (
        <ShipperActionButtons isQuickRequest={isQuickRequest} />
      ) : (
        <>
          {isProviderQuotationPage && !hasParentShipment && <ProviderQuotationActionButtons />}
          {!showIntermediateInMultistopComposer && isProviderTrackingPage && <ProviderTrackingActionButtons />}
        </>
      )}
    </div>
  );
}
